"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iterTree = void 0;
var IRApp_1 = require("../../IRNodes/IRApp.js");
var IRCase_1 = require("../../IRNodes/IRCase.js");
var IRConstr_1 = require("../../IRNodes/IRConstr.js");
var IRDelayed_1 = require("../../IRNodes/IRDelayed.js");
var IRForced_1 = require("../../IRNodes/IRForced.js");
var IRFunc_1 = require("../../IRNodes/IRFunc.js");
var IRHoisted_1 = require("../../IRNodes/IRHoisted.js");
var IRLetted_1 = require("../../IRNodes/IRLetted.js");
function iterTree(_term, fn, 
// necessary for letted hash calculation (exclude hoisted)
shouldSkipNode) {
    var has_shouldSkipNode = typeof shouldSkipNode === "function";
    var stack = [{ term: _term, dbn: 0 }];
    var _loop_1 = function () {
        var _a = stack.pop(), t = _a.term, dbn = _a.dbn;
        if (has_shouldSkipNode && shouldSkipNode(t, dbn))
            return "continue";
        var termParent = t.parent;
        var negDbn = t instanceof IRFunc_1.IRFunc ? t.arity : 0;
        var modifiedParent = fn(t, dbn) === true;
        if (modifiedParent && termParent !== undefined) {
            while (stack.length > 0 && stack[stack.length - 1].isIRAppArg) {
                // there is an extra node 
                stack.pop();
            }
            stack.push({ term: termParent, dbn: dbn - negDbn });
            return "continue";
        }
        if (t instanceof IRApp_1.IRApp) {
            stack.push({ term: t.fn, dbn: dbn }, { term: t.arg, dbn: dbn, isIRAppArg: true });
            return "continue";
        }
        if (t instanceof IRDelayed_1.IRDelayed) {
            stack.push({ term: t.delayed, dbn: dbn });
            return "continue";
        }
        if (t instanceof IRForced_1.IRForced) {
            stack.push({ term: t.forced, dbn: dbn });
            return "continue";
        }
        if (t instanceof IRFunc_1.IRFunc) {
            stack.push({ term: t.body, dbn: dbn + t.arity });
            return "continue";
        }
        if (t instanceof IRCase_1.IRCase) {
            stack.push.apply(stack, __spreadArray([{ term: t.constrTerm, dbn: dbn }], __read(Array.from(t.continuations).map(function (cont) {
                return ({ term: cont, dbn: dbn, isIRAppArg: true });
            })), false));
            return "continue";
        }
        if (t instanceof IRConstr_1.IRConstr) {
            stack.push.apply(stack, __spreadArray([], __read(Array.from(t.fields).map(function (f) {
                return ({ term: f, dbn: dbn, isIRAppArg: true });
            })), false));
            return "continue";
        }
        if (t instanceof IRHoisted_1.IRHoisted) {
            // 0 because hoisted are closed
            // for hoisted we keep track of the depth inside the term
            stack.push({ term: t.hoisted, dbn: 0 });
            return "continue";
        }
        if (t instanceof IRLetted_1.IRLetted) {
            // same stuff as the hoisted terms
            // the only difference is that depth is then incremented
            // once the letted term reaches its final position
            stack.push({ term: t.value, dbn: dbn });
            return "continue";
        }
    };
    while (stack.length > 0) {
        _loop_1();
    }
}
exports.iterTree = iterTree;
